/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespHeroCarousel_viewer = {
    readonly videoUploadToolsFeatureFlag: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubblesWrapper_viewer">;
    readonly " $refType": "PdpRespHeroCarousel_viewer";
};
export type PdpRespHeroCarousel_viewer$data = PdpRespHeroCarousel_viewer;
export type PdpRespHeroCarousel_viewer$key = {
    readonly " $data"?: PdpRespHeroCarousel_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarousel_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_viewer",
  "selections": [
    {
      "alias": "videoUploadToolsFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "videoUploadTools"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"videoUploadTools\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '64869111803ece798612de5aa78b0ef7';
export default node;
